module.exports = __webpack_public_path__ + "img/image-about-us-04-academy-template.b377e26d.jpg";